module.exports = __webpack_public_path__ + "img/custom.66c08bd1.png";